export default "__VITE_ASSET__7P_t_8br__"